import React from 'react';
import { Route } from 'react-router-dom'
import MatchHydrate from './../components/match-hydrate.js';
import Home from './../components/home.js';
import Casino from './../components/casino.js';
import Shop from './../components/shop.js';
import Sportsbook from './../components/sportsbook.js';
import Login from './../components/login.js';
import Register from './../components/register.js';
import RegisterDetails from './../components/register-details.js';
import MenuGlobal from './../components/menu-global.js';
import Account from '../components/account/account.js';
import PaymentResult from './../components/payment-result.js';
import WithTemp from './../components/withtemp.js';
import About from './../components/about.js';
import Logout from './../components/logout.js';
import PrivacyPolicy from './../components/privacy-policy.js';
import TermsConditions from './../components/terms-conditions.js';
import ResponsibleGaming from './../components/responsible-gaming.js';
import EmailVerifyResult from './../components/email-verify-result.js';
import playerStatus from './../player-status.js';
import { initRealityCheck } from '../reality-check/reality-check.js';
import pixelTracking from './../pixel-tracking/pixel-tracking.js';
/**
 *  React Root element. It defines core application routes.
 *  Docs can be found on https://react-router.now.sh/. (it uses react-router v4)
 *  Use <MatchHydrate> if props needs to be passed to hydrate the view.
 *  Use 'authenticate' to enforce login.
 */
playerStatus.init();
initRealityCheck();
pixelTracking.push('site');
pixelTracking.pushFromCookies();

const Routes = () => (
	<div>
		<Route path="/" component={Home} exact />
		<Route path="/casino" component={Casino} />
		<Route path="/shop" component={Shop} />
		<Route path="/sportsbook" component={Sportsbook} />
		<Route path="/sports" component={Sportsbook} />
		<Route path="/login" component={Login} />
		<Route path="/register" component={Register} />
		<Route path="/register/details" component={RegisterDetails} />
		<Route path="/global" component={MenuGlobal} />
		<Route path="/privacy_policy" component={PrivacyPolicy} />
		<Route path="/terms_and_conditions" component={TermsConditions} />
		<Route path="/responsible_gaming" component={ResponsibleGaming} />
		<Route path="/about" component={About} />
		<Route path="/logout" component={Logout} />
		<Route path="/verify-email/*" component={EmailVerifyResult} />
		<MatchHydrate path="/bonus-codes" component={Shop} authenticate />
		<MatchHydrate path="/account" component={Account} authenticate />
		<MatchHydrate path="/withtemp" component={WithTemp} authenticate />
		<MatchHydrate path="/payment/result/:type" component={PaymentResult} authenticate />
	</div>
);

export default Routes;



// WEBPACK FOOTER //
// ./mobile-core/src/router/routes.js